import { isUndefined as isUndefinedLodash } from 'lodash-es';

export function isUndefined(value: unknown): boolean {
  return isUndefinedLodash(value);
}
